import React from 'react';

import Typography from '@hpstellar/core/visId/Typography';
import Link from '@hpstellar/core/visId/Link';

import './intopic-articles.less';

const RelatedArticle = ({ description, vanityUrl, blogTitle }) => (
    <div className='intopic-article'>
        <Typography className='intopic-article-title' variant='h4'>{blogTitle}</Typography>
        {description && <Typography className='intopic-article-description' variant='body1' tag='p'>{description}</Typography>}
        {vanityUrl && <Link to={`${process.env.BASENAME}/${vanityUrl}`} target='_blank' fontWeight={700}>Read more</Link>}
    </div>
)

export default ({ blogs, className }) => {
    if(!Array.isArray(blogs) || blogs.length < 1) return null;

    const intopicBlogs = blogs.reduce((allBlogs, blog, idx) => {
        const { blurb , description, blogTitle, vanityUrl } = blog || {};
        if(typeof vanityUrl === 'string' && blogTitle){
            allBlogs.push(
                <RelatedArticle 
                    key={`${vanityUrl}-${idx}`}
                    description={blurb || description}
                    vanityUrl={vanityUrl}
                    blogTitle={blogTitle}
                />
            )
        }
        return allBlogs;
    }, []);

    return intopicBlogs.length > 0 && (
        <div className={`${className ? className + ' ' : ''}intopic-articles-section`}>
            <Typography className='intopic-articles-section-title' variant="h2">Related articles</Typography>
            <div className='intopic-articles-container'>
                { intopicBlogs }
            </div>
        </div>
    );
};